import { FC } from 'react';
import { Drawer, Portal, CloseButton } from '@chakra-ui/react';
import {
  TreeStructure,
  MagnifyingGlass,
  Lightning,
  LinkSimple,
  ArrowsLeftRight,
  Timer,
  CalendarDots,
  ArrowsOut,
} from '@phosphor-icons/react';
import Typhography from '../../../shared/Typhography/Typhography';
import styles from './HelpDrawer.module.scss';

interface HelpDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const helpItems = [
  {
    icon: <TreeStructure size={18} color="#063444" weight="duotone" />,
    title: 'Struttura',
    desc: 'La scheda è organizzata in Giorni → Blocchi → Esercizi. Ogni blocco ha un tipo (Forza massima, Ipertrofia, ecc.) che ne determina il colore.',
  },
  {
    icon: <MagnifyingGlass size={18} color="#063444" weight="duotone" />,
    title: 'Aggiungere esercizi',
    desc: 'Clicca su "Cerca esercizio..." per aprire il catalogo. Puoi cercare per nome o filtrare per gruppo muscolare.',
  },
  {
    icon: <Lightning size={18} color="#063444" weight="duotone" />,
    title: 'Metodi',
    desc: 'Ogni esercizio può avere un metodo specifico: Standard, EMOM, Tabata, Tempo, AMRAP, Cluster, Rest-Pause, Isometrico, Drop Set, Piramidale. I campi cambiano in base al metodo selezionato.',
  },
  {
    icon: <LinkSimple size={18} color="#063444" weight="duotone" />,
    title: 'Superset',
    desc: 'Trascina un esercizio sopra un altro per creare un superset (A1/A2). Serie e recupero sono condivisi nel gruppo. Puoi anche selezionare più esercizi con le checkbox e cliccare "Raggruppa in Superset".',
  },
  {
    icon: <ArrowsLeftRight size={18} color="#063444" weight="duotone" />,
    title: 'Lateralità',
    desc: "Attiva il toggle \"Per lato\" per esercizi unilaterali. L'atleta vedrà righe separate per destro e sinistro durante l'esecuzione.",
  },
  {
    icon: <Timer size={18} color="#063444" weight="duotone" />,
    title: 'EMOM Sub-esercizi',
    desc: "Quando selezioni il metodo EMOM, puoi aggiungere sub-esercizi al round. Il numero di round viene calcolato automaticamente dalla durata e dall'intervallo.",
  },
  {
    icon: <CalendarDots size={18} color="#063444" weight="duotone" />,
    title: 'Multi-giorno',
    desc: 'Seleziona "Multi-giorno" per creare schede con più giorni. Ogni giorno può avere blocchi ed esercizi diversi.',
  },
  {
    icon: <ArrowsOut size={18} color="#063444" weight="duotone" />,
    title: 'Espandi/Comprimi',
    desc: 'Clicca su un esercizio collassato per espanderlo e modificare i parametri. Usa "Espandi tutti" / "Comprimi tutti" nel blocco.',
  },
];

const HelpDrawer: FC<HelpDrawerProps> = ({ isOpen, onClose }) => {
  return (
    <Drawer.Root open={isOpen} onOpenChange={(e) => { if (!e.open) onClose(); }} placement="end" size="sm">
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.Header className={styles.header}>
              <Typhography size="bold-20" className={styles.cardTitle}>Come funziona</Typhography>
              <Typhography size="regular-14" className={styles.subtitle}>Guida rapida al workout builder</Typhography>
            </Drawer.Header>
            <Drawer.Body className={styles.body}>
              {helpItems.map((item, i) => (
                <div key={i} className={styles.card}>
                  <div className={styles.iconWrapper}>
                    {item.icon}
                  </div>
                  <div className={styles.cardContent}>
                    <Typhography size="bold-14" className={styles.cardTitle}>{item.title}</Typhography>
                    <Typhography size="regular-14" className={styles.cardDesc}>{item.desc}</Typhography>
                  </div>
                </div>
              ))}
            </Drawer.Body>
            <Drawer.CloseTrigger asChild onClick={onClose}>
              <CloseButton size="sm" />
            </Drawer.CloseTrigger>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
};

export default HelpDrawer;
